/**
 * appends params to a url
 * @param {Object} item - Original item
 * @param {number} shippingCost - Parameters to append
 * @returns {string} result renderItem with appended parameters
 */
function renderHTMLForOrderTotalsDiscounts(item) {
    if (item.lineItemText) {
    // eslint-disable-next-line
        const renderItem = `<div class="ds-row cost-item ${(item.promotionClass === 'SHIPPING') || !item.lineItemText ? 'd-none' : ''}">
                                <div class="column xs-7 cost-item--key">
                                    <p>
                                        ${item.lineItemText}
                                    </p>
                                </div>
                                <div class="column xs-5 cost-item--value">
                                    <p class="text-right">${item.price}</p>
                                </div>
                                </div>`;
        return renderItem;
    }
    return '';
}

const renderingCartTemplates = {
    renderHTMLForOrderTotalsDiscounts: renderHTMLForOrderTotalsDiscounts
};

module.exports = renderingCartTemplates;
